export const MOBILE_SIZE = 640;
export const TABLET_SIZE = 900;